import React from "react";
import { Stack, Typography, Link, Box, Paper } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew"; // Add this import

interface SetupGuideCardProps {
  title: string;
  links: { text: string; href: string }[];
  videoSrc?: string;
}

const SetupGuideCard = ({ title, links, videoSrc }: SetupGuideCardProps) => {
  return (
    <Paper
      elevation={2}
      sx={{
        m: 3,
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      <Stack
        sx={{
          p: 4,
          bgcolor: "background.paper",
        }}
        direction={{ xs: "column", md: "row" }}
        spacing={4}
      >
        <Stack spacing={3} sx={{ flex: 1 }}>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 600,
              color: "primary.secondary",
              pb: 1,
              borderBottom: "2px solid",
              borderColor: "primary.light",
            }}
          >
            {title}
          </Typography>

          {videoSrc && (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%", // 16:9 Aspect Ratio
                bgcolor: "grey.100",
                borderRadius: 1,
                overflow: "hidden",
              }}
            >
              <iframe
                src={videoSrc}
                title={title}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          )}

          <Stack spacing={1.5}>
            {links.map((link, index) => (
              <Link
                key={index}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "primary.main",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "primary.dark",
                  },
                }}
              >
                {link.text}
                <OpenInNewIcon sx={{ ml: 0.5, fontSize: "1rem" }} />
              </Link>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default SetupGuideCard;
